export const categories = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html", icon: "ri-footprint-line" },
  { name: "Hoodies &amp; Sweaters", url: "https://kaspreadsheet.com/search-912/name/Shoes.html", icon: "ri-shirt-line" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html", icon: "ri-t-shirt-line" },
  { name: "Jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html", icon: "ri-honour-line" },
  { name: "Pants &amp; Shorts", url: "https://kaspreadsheet.com/search-915/name/Shoes.html", icon: "ri-pantone-line" },
  { name: "Headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html", icon: "ri-customer-service-line" },
  { name: "Sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html", icon: "ri-stack-line" },
  { name: "Underwear &amp; Underpants", url: "https://kaspreadsheet.com/search-918/name/Shoes.html", icon: "ri-checkbox-blank-line" },
  { name: "Jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html", icon: "ri-basketball-line" },
  { name: "Accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html", icon: "ri-glasses-line" },
  { name: "Bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html", icon: "ri-handbag-line" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html", icon: "ri-link" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html", icon: "ri-drop-line" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Shoes.html", icon: "ri-more-line" },
];

export const mainSiteUrl = "https://kaspreadsheet.com";

export const siteUrl = "https://basetaosheet.living";

export const comparisonData = [
  { feature: "Product Organization", basetao: "Advanced spreadsheet system", traditional: "Manual note-taking" },
  { feature: "Price Tracking", basetao: "Built-in tracking tools", traditional: "Manual comparison" },
  { feature: "Research Speed", basetao: "Fast & efficient", traditional: "Time-consuming" },
  { feature: "Community Data", basetao: "Strong shared database", traditional: "Limited individual data" },
  { feature: "Shipping Estimation", basetao: "Integrated calculator", traditional: "Separate research required" },
];

export const faqData = [
  {
    question: "What is BaseTao Spreadsheet?",
    answer: "BaseTao Spreadsheet is a research and organization tool designed to help shoppers systematically track products, compare prices, estimate shipping costs, and manage their purchasing decisions across multiple categories including shoes, clothing, accessories, and more.",
  },
  {
    question: "How does BaseTao Spreadsheet help save money?",
    answer: "By organizing product data, tracking price changes, and providing shipping cost estimates in one place, BaseTao Spreadsheet helps you make informed comparisons and avoid unnecessary expenses. Combined with our coupon and discount guides, you can optimize your total shopping cost.",
  },
  {
    question: "Is BaseTao Spreadsheet suitable for beginners?",
    answer: "Yes, our beginner-friendly guides walk you through every step. The spreadsheet templates and tutorials are designed for users of all experience levels, from first-time shoppers to experienced buyers looking to optimize their workflow.",
  },
  {
    question: "Which countries does BaseTao ship to?",
    answer: "BaseTao offers shipping to major destinations worldwide including the USA, UK, Canada, Australia, and most European countries. Shipping times and costs vary by destination and shipping line selection. Check our shipping cost guide for detailed country-specific estimates.",
  },
  {
    question: "How do I find working BaseTao coupon codes?",
    answer: "We maintain an updated coupon and discount guide that tracks current promotions, seasonal offers, and verified discount methods. Visit our coupon guide section for the latest money-saving opportunities and strategies.",
  },
];